module.exports = __webpack_public_path__ + "img/pdf_bg_results_4.f807f385.png";